import React from "react";
import { ReactComponent as Star } from "design_system/src/static/icons/star.svg";
import { ReactComponent as StarFilled } from "design_system/src/static/icons/star-filled.svg";

interface ReviewBarProps {
  value?: number;
}

const ReviewBar = ({ value }: ReviewBarProps) => {
  if (value === undefined || value < 0 || value > 100) return null;

  return (
    <div
      style={{
        width: "100%",
        height: 9,
        background: "#FFF5EA",
        borderRadius: 8,
        overflow: "hidden",
        position: "relative",
      }}
    >
      <div
        style={{
          width: `${value}%`,
          height: "100%",
          background: "#FF9100",
          borderRadius: 8,
          transition: "width 0.3s",
        }}
      />
    </div>
  );
};

export default ReviewBar;
